import { format } from 'date-fns'
import { Copy, Video } from 'lucide-react'

import { useMeetsProximos } from '@/hooks/useMeetsProximos'
import { copiarEnlaceMeet } from '@/lib/copiar-enlace'

/** Solo lo inminente: en el calendario, la cola ya se ve en la grilla. */
const DIAS_HORIZONTE = 1

/**
 * Franja de reuniones de hoy y mañana, arriba del calendario.
 *
 * Es la misma información que la tarjeta de Inicio, en el formato que pide esta vista: acá la
 * grilla ya muestra el mes, así que repetir una lista sería ruido. Lo que la grilla NO muestra
 * es la hora ni el enlace, y eso es lo que queda a mano.
 */
export function MeetsBanner() {
  const { meets } = useMeetsProximos(DIAS_HORIZONTE)

  if (meets.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border bg-muted/40 p-2">
      <span className="flex items-center gap-1.5 px-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        <Video className="h-3.5 w-3.5" />
        Reuniones
      </span>

      {meets.map(({ meet, franja, inicio }) => (
        <span
          key={meet.id}
          className="flex items-center gap-2 rounded-md border bg-background px-2.5 py-1 text-xs"
        >
          <span
            className={`h-2 w-2 shrink-0 rounded-full ${
              franja === 'hoy' ? 'bg-emerald-500' : 'bg-amber-500'
            }`}
            aria-hidden="true"
          />
          <span className="font-semibold">{franja === 'hoy' ? 'Hoy' : 'Mañana'}</span>
          {!meet.todo_el_dia && (
            <span className="font-mono tabular-nums">{format(inicio, 'HH:mm')}</span>
          )}
          <span className="max-w-40 truncate">{meet.titulo}</span>
          {meet.meet_url && (
            <button
              type="button"
              onClick={() => copiarEnlaceMeet(meet.meet_url!)}
              className="text-muted-foreground transition-colors hover:text-foreground"
              aria-label={`Copiar enlace de ${meet.titulo}`}
            >
              <Copy className="h-3.5 w-3.5" />
            </button>
          )}
        </span>
      ))}
    </div>
  )
}
